const awsconfig = {
  /**
   * Read by `services/auth.ts`, which builds `UserManagerSettings` from it.
   *
   * The env-var contract in `service.manifest.json` and `.env.example` is written
   * against this shape, so these keys are not free to be renamed.
   *
   * The user-pool domain is absent: discovery resolves every endpoint from the issuer.
   * The response type is absent too — `services/auth.ts` states `code` unconditionally;
   * making it configurable would let an env var select the implicit grant, which
   * returns no refresh token and breaks silent renew.
   */
  Auth: {
    region: import.meta.env.VITE_REGION,
    userPoolId: import.meta.env.VITE_USER_POOL,
    userPoolWebClientId: import.meta.env.VITE_CLIENTID,
    oauth: {
      scope: ['email', 'openid', 'profile', 'user/*.read', 'user/*.write'],
      redirectSignIn: import.meta.env.VITE_REDIRECT_SIGNIN_URL,
      redirectSignOut: import.meta.env.VITE_REDIRECT_SIGNOUT_URL,
    },
  },
  Google: {
    endpoints: {
      // Carries no value: nothing reads this key, and the build exposes only VITE_-prefixed
      // variables to the bundle.
      mapkey: undefined,
    },
  },
  API: {
    endpoints: [
      {
        name: import.meta.env.VITE_API_NAME,
        endpoint: import.meta.env.VITE_API_ENDPOINT,
      },
      {
        name: import.meta.env.VITE_FOODCOURT_API_NAME,
        endpoint: import.meta.env.VITE_FOODCOURT_API_ENDPOINT,
      },
      {
        name: import.meta.env.VITE_CARE_HOOKS_API_NAME,
        endpoint: import.meta.env.VITE_CARE_HOOKS_API_ENDPOINT,
      },
      {
        name: import.meta.env.VITE_CARE_LYTICS_API_NAME,
        endpoint: import.meta.env.VITE_CARE_LYTICS_API_ENDPOINT,
      },
      {
        name: import.meta.env.VITE_CONNECT_HOOKS_API_NAME,
        endpoint: import.meta.env.VITE_CONNECT_HOOKS_API_ENDPOINT,
      },
    ],
  },
};

export default awsconfig;
